import { Col, Row } from "react-bootstrap";
import { Product } from "models/Product";
import trashImg from '../../images/trash.png';
import { useCart } from "contexts/CartProvider";
import QuantityPicker from "components/Shared/QuantityPicker";
import { useState } from "react";
import ProductPrice from '../Shared/ProductPrice';
import { FormattedMessage, useIntl } from "react-intl";

const ProductItemMobileView = ({ product }: { product: Product }) => {
    const { removeFromCart, updateItem } = useCart(),
        [quantity, setQuantity] = useState(product.quantity);
    const minQty = 0, maxQty = 99;
    const handleDeleteBtnClick = () => {
        removeFromCart(product);
    };
    const quantityChange = (e: any) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value && re.test(e.target.value)) {

            setProductQuantity(parseInt(e.target.value));
        } else {
            setProductQuantity(0);
        }
    };
    const setProductQuantity = (qty: number) => {
        console.log(qty);
        if (qty > maxQty) qty = maxQty;
        if (qty < minQty) qty = minQty;
        console.log(`Going to set number to ${qty}`);
        setQuantity(qty);
        updateItem(product, qty);
    };
    const intl = useIntl();
    return <>
        <Row className="product-item p-2">
            <Col>
                <Row className="mb-3">
                    <Col sm={4} xs={4}>
                        <img src={`${import.meta.env.VITE_ONLINE_SHOP_BASE_URL}/images/products/${product.image}`} className="product-img-mobile" alt={product.materialDescription}></img>
                    </Col>
                    <Col sm={8} xs={8}>
                        <p>{product.materialLongDescription}</p>
                        <p className="my-auto"><ProductPrice price={product.optimizedPrice} /></p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col sm={5} xs={5} className="fw-bold">
                        <FormattedMessage id="ml_114614" defaultMessage="X - Quantity" />
                    </Col>
                    <Col sm="auto" xs="auto">
                        <QuantityPicker quantity={quantity}
                            minusClickHandler={() => setProductQuantity(parseInt(quantity.toString()) - 1)}
                            plusClickHandler={() => setProductQuantity(parseInt(quantity.toString()) + 1)}
                            onChangeHandler={quantityChange} label={intl.formatMessage({ id: 'ml_114614', defaultMessage: 'Quantity' })}></QuantityPicker>
                    </Col>
                </Row>
                <Row>
                    <Col sm={5} xs={5} className="fw-bold">
                        <FormattedMessage id="ml_114615" defaultMessage="X - TOTAL(EXCL VAT)" />
                    </Col>
                    <Col sm={5} xs={5} className="p-0">
                        <ProductPrice price={product.optimizedPrice} quantity={quantity} />
                    </Col>
                    <Col sm="auto" xs="auto">
                        <img className="product-delete-btn" src={trashImg} onClick={handleDeleteBtnClick} alt={intl.formatMessage({ id: 'ml_153094', defaultMessage: 'Delete Item' })}></img>
                    </Col>
                </Row>
            </Col>
        </Row>
    </>;
};


export default ProductItemMobileView;